// Import ----------------------------------------------------------------------

// Project
import { VueGlobalInjectable } from "~/libs/Types";

// Export ----------------------------------------------------------------------

export default VueGlobalInjectable.extend({

    // Component Internal Data State -------------------------------------------

    data: () => ({
        // Initialize scroll position at [0, 0]
        scrollPosition: { x: 0, y: 0 }
    }),

    // Life Cycle Hooks --------------------------------------------------------

    created () {
        // Only execute this code on the client side
        // server sticks defaults to [0, 0]
        if (this.$isServer) {
            return;
        }

        // Call listener once to detect initial position
        this._scrollListener();

        // When scrolling, update the position
        window.addEventListener("scroll", this._scrollListener);
    },

    beforeDestroy () {
        // Detach the listener when the component is gone
        window.removeEventListener("scroll", this._scrollListener);
    },

    // Methods / Functions  ----------------------------------------------------

    methods: {
        /**
         * We round values because high-DPI devies can provide some really nasty
         * subpixel values.
         *
         * Window.pageX/YOffset is equivalent to window.scrollX/Y, but works in
         * all browsers including IE.
         */
        _scrollListener () {
            // Fallback to the modern scrollX/Y to making it future proof
            const x = window.pageXOffset ?? window.scrollX;
            const y = window.pageYOffset ?? window.scrollY;

            this.scrollPosition = {
                x: Math.round(x),
                y: Math.round(y)
            };
        }
    }
});
